// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2137":"2725dd987c1b10fb","2338":"077b32649531fbe0","2964":"43abf21bbf5de05b","3486":"9bcaf127b06b5831","3744":"1da87903329ce29f","5277":"19085b5341151105","6265":"1ed9f90202abf9f9","6555":"a4970015a3906f9a","8684":"50b38a6a0579613b"}[chunkId] + ".js";
};